/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * DTO for updating a waiting room.
 * @export
 * @interface UpdateInstituteRoom
 */
export interface UpdateInstituteRoom {
    /**
     * Unique identifier of the institute address.
     * @type {string}
     * @memberof UpdateInstituteRoom
     */
    addressId?: string;
    /**
     * Details about the live room.
     * @type {string}
     * @memberof UpdateInstituteRoom
     */
    liveRoomDetails: string;
    /**
     * Indicates if this is the default waiting room.
     * @type {boolean}
     * @memberof UpdateInstituteRoom
     */
    byDefault?: boolean;
    /**
     * Unique identifier of the room badge.
     * @type {string}
     * @memberof UpdateInstituteRoom
     */
    roomBadgeId?: string;
}

/**
 * Check if a given object implements the UpdateInstituteRoom interface.
 */
export function instanceOfUpdateInstituteRoom(value: object): value is UpdateInstituteRoom {
    if (!('liveRoomDetails' in value) || value['liveRoomDetails'] === undefined) return false;
    return true;
}

export function UpdateInstituteRoomFromJSON(json: any): UpdateInstituteRoom {
    return UpdateInstituteRoomFromJSONTyped(json, false);
}

export function UpdateInstituteRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateInstituteRoom {
    if (json == null) {
        return json;
    }
    return {
        
        'addressId': json['addressId'] == null ? undefined : json['addressId'],
        'liveRoomDetails': json['liveRoomDetails'],
        'byDefault': json['byDefault'] == null ? undefined : json['byDefault'],
        'roomBadgeId': json['roomBadgeId'] == null ? undefined : json['roomBadgeId'],
    };
}

export function UpdateInstituteRoomToJSON(json: any): UpdateInstituteRoom {
    return UpdateInstituteRoomToJSONTyped(json, false);
}

export function UpdateInstituteRoomToJSONTyped(value?: UpdateInstituteRoom | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'addressId': value['addressId'],
        'liveRoomDetails': value['liveRoomDetails'],
        'byDefault': value['byDefault'],
        'roomBadgeId': value['roomBadgeId'],
    };
}

